// Client-side leg of the Feedback lessons filters (the backend filters by
// status / source / profile; whether a row wrote anything is decided here).

import type { LedgerSummary } from '../../services/feedbackLearning';

export type KbWriteFilter = 'any' | 'written' | 'none';

export function matchesKbWriteFilter(row: LedgerSummary, filter: KbWriteFilter): boolean {
  const wrote = (row.kb_writes?.length ?? 0) > 0;
  if (filter === 'written') return wrote;
  if (filter === 'none') return !wrote;
  return true;
}
